//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue              from 'vue';
import Component        from 'vue-class-component';
import MarkdownDocument from '@/components/MarkdownDocument';
import { STORAGE_URL }  from '@/assets/json/config';
import MD_STANDARD      from '@/classes/MdStandard.enum';

@Component({
	components : {
		MarkdownDocument,
	},
})
export default class Changelog extends Vue {
	// Constants passthrough
	//--------------------------------------------------------------------------------------------------

	MD_STANDARD = MD_STANDARD;
	STORAGE_URL = STORAGE_URL;
}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<MarkdownDocument
	:title    = "`v${$route.params.id} Changelog`"
	:filename = "`${STORAGE_URL}/changelogs/${$route.params.id}.md`"
	:standard = "MD_STANDARD.SYSTEM"
>
	Changelog Not Found
</MarkdownDocument>
</template>
